const LOAD_DATA_MASTER_BUSINESS_SECTOR           = 'LOAD_DATA_MASTER_BUSINESS_SECTOR'
const LOAD_DATA_MASTER_BUSINESS_SECTOR_SUCCESS   = 'LOAD_DATA_MASTER_BUSINESS_SECTOR_SUCCESS'
const LOAD_DATA_MASTER_BUSINESS_SECTOR_FAILED    = 'LOAD_DATA_MASTER_BUSINESS_SECTOR_FAILED'
const UNMOUNT_DATA_MASTER_BUSINESS_SECTOR        = 'UNMOUNT_DATA_MASTER_BUSINESS_SECTOR'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterBusinessSectorReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_BUSINESS_SECTOR:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_BUSINESS_SECTOR_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_BUSINESS_SECTOR_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_BUSINESS_SECTOR:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterBusinessSectorReducer;